// Auto-generated by build script - DO NOT EDIT
export const API_URL = "https://hawkeye-backend.kv9898.workers.dev";
